import bandsConfig from '@public/bands.json';

export type BandId = 'excellent' | 'covered' | 'limited' | 'far' | 'out_of_region';

export type BandConfig = {
  coveredFromKm: number;
  limitedFromKm: number;
  farFromKm: number;
  outOfRegionFromKm: number;
};

export const BANDS: BandConfig = bandsConfig;

export const resolveBand = (distanceKm: number, config: BandConfig = BANDS): BandId => {
  if (distanceKm >= config.outOfRegionFromKm) {
    return 'out_of_region';
  }
  if (distanceKm >= config.farFromKm) {
    return 'far';
  }
  if (distanceKm >= config.limitedFromKm) {
    return 'limited';
  }
  if (distanceKm >= config.coveredFromKm) {
    return 'covered';
  }
  return 'excellent';
};

/* What the page can honestly promise this lead, or nothing at all.

   `arrives` is for the two bands whose copy already says we will get in touch. `improves`
   is for the band that can ride today but may not feel ready: promising to "arrive" there
   would undersell a network that already reaches them, so the offer is to report the next
   station instead. Within 5 km there is nothing to wait for, and asking would invent a
   doubt the lead did not have. */
export type NotifyIntent = 'improves' | 'arrives';

export const notifyIntentFor = (band: BandId): NotifyIntent | null => {
  if (band === 'far' || band === 'out_of_region') {
    return 'arrives';
  }
  return band === 'limited' ? 'improves' : null;
};
